function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-notify"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "notify",
  clipPath: "url(#clip-notify)"
}, /*#__PURE__*/React.createElement("g", {
  id: "bell-outline",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M15.39,11.408,14.04,10.05V6.7a5.145,5.145,0,0,0-4.365-5.16,5.055,5.055,0,0,0-5.715,5v3.5L2.61,11.408A1.23,1.23,0,0,0,3.48,13.5H6v.255A2.88,2.88,0,0,0,9,16.5a2.88,2.88,0,0,0,3-2.745V13.5h2.52a1.23,1.23,0,0,0,.87-2.092ZM10.5,13.755A1.41,1.41,0,0,1,9,15a1.41,1.41,0,0,1-1.5-1.245V13.5h3ZM4.133,12l.885-.885A1.5,1.5,0,0,0,5.46,10.05v-3.5a3.548,3.548,0,0,1,1.215-2.67A3.5,3.5,0,0,1,9.48,3a3.645,3.645,0,0,1,3.06,3.675V10.05a1.5,1.5,0,0,0,.435,1.065l.892.885Z",
  fill: "currentColor"
})));

var SvgNotify = function SvgNotify(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotify, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notify.5d246e1c.svg";
export { ForwardRef as ReactComponent };